import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FLOCK_VARIANT, FlockModuleState } from '../../models/flock.model';
import { adapter } from '../reducers/flock.reducer';

const { selectAll } = adapter.getSelectors();

export const getFlockModuleState = createFeatureSelector<FlockModuleState>('flockModule');

export const getFlockState = createSelector(getFlockModuleState, (state) => state.flocks);

export const getFlocks = createSelector(getFlockState, selectAll);

export const getFlocksForAllLocationsState = createSelector(
  getFlockModuleState,
  (state) => state.flocksForAllLocations,
);

export const getFlocksForAllLocations = createSelector(getFlocksForAllLocationsState, selectAll);

export const getSelectedFlockId = createSelector(
  getFlockModuleState,
  (state) => state.selectedFlockId,
);

export const getFlockVariant = createSelector(
  getFlockModuleState,
  (state) => state.flockVariant ?? FLOCK_VARIANT.Layer,
);

export const getSelectedFlock = createSelector(getFlocks, getSelectedFlockId, (flocks, flockId) =>
  !!flocks && flocks?.length > 0 ? flocks.find((c) => c.id === flockId) : undefined,
);

export const getSelectedFlockWeekData = createSelector(
  getFlockModuleState,
  (state) => state.selectedFlockWeekData,
);

export const getSelectedOtherFlockWeekData = createSelector(
  getFlockModuleState,
  (state) => state.selectedOtherFlockWeekData,
);

export const getSelectedOtherFlockName = createSelector(getSelectedOtherFlockWeekData, (state) =>
  state?.data?.length > 0 ? state.data[0].info.flockName : null,
);

export const getHatcheries = createSelector(getFlockModuleState, (state) =>
  !!state && !!state.hatcheries
    ? state.hatcheries.slice().sort((a, b) => a.name.localeCompare(b.name))
    : [],
);

export const getRearingOrganizations = createSelector(getFlockModuleState, (state) =>
  !!state && !!state.rearingOrganizations
    ? state.rearingOrganizations.slice().sort((a, b) => a.name.localeCompare(b.name))
    : [],
);

export const getDeliveryLines = createSelector(getFlockModuleState, (state) => state.deliveryLines);

export const getPorphyrioCategories = createSelector(
  getFlockModuleState,
  (state) => state.porphyrioCategories,
);

export const getFlockWeekChartFilters = createSelector(
  getFlockModuleState,
  (state) => state.flockWeekChartFilters,
);

export const getWeekRegistrationFilters = createSelector(
  getFlockModuleState,
  (state) => state.weekRegistrationFilters,
);

export const getIsDetailedViewSelected = createSelector(
  getFlockModuleState,
  (state) => state.isDetailedViewSelected,
);

export const getFarmResources = createSelector(getFlockModuleState, (state) => state.farmResources);

export const getFlockResources = createSelector(
  getFlockModuleState,
  (state) => state.flockResources,
);

export const getCarbonFootprint = createSelector(
  getFlockModuleState,
  (state) => state.carbonFootprint,
);

export const selectSustainabilityNoticeVisibility = createSelector(
  getFlockModuleState,
  (state) => state.sustainabilityNoticeVisible,
);
